var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4952",
    "data-name": "Group 4952",
    transform: "translate(1633 18627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4937",
    "data-name": "Group 4937",
    transform: "translate(-1924 -18776)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(291 149)",
    fill: "#18beb3",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4938",
    "data-name": "Group 4938",
    transform: "translate(-1621 -18615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5662",
    "data-name": "Path 5662",
    d: "M4,0V17a.945.945,0,0,1-1,1,.945.945,0,0,1-1-1V12H0v5a2.946,2.946,0,0,0,3,3H17a2.946,2.946,0,0,0,3-3V0ZM18,17a.945.945,0,0,1-1,1H5.8A2.959,2.959,0,0,0,6,17V2H18Z",
    fill: "#18beb3",
    stroke: "#cfe1df",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2399",
    "data-name": "Rectangle 2399",
    width: 8,
    height: 2,
    transform: "translate(8 4)",
    fill: "#18beb3",
    stroke: "#cfe1df",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2400",
    "data-name": "Rectangle 2400",
    width: 8,
    height: 2,
    transform: "translate(8 8)",
    fill: "#18beb3",
    stroke: "#cfe1df",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2401",
    "data-name": "Rectangle 2401",
    width: 8,
    height: 2,
    transform: "translate(8 12)",
    fill: "#18beb3",
    stroke: "#cfe1df",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.4986348c82d9e083c6d3979b89e69ead.svg";
export { ForwardRef as ReactComponent };